import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { withRouter, Link } from 'react-router'
import { inject, observer } from 'mobx-react'
import StoreShape from '../../shared/store-proptypes'
import { FRONTEND_URL } from '../../config'
import { version } from '../../../package.json'

@inject('auth') @observer
class SecondaryNav extends Component {

  static propTypes = {
    auth: StoreShape,
    router: PropTypes.shape({
      push: PropTypes.func
    })
  }

  @autobind
  handleStopImpersonating() {
    this.props.auth.stopImpersonate()
  }

  @autobind
  handleLogout() {
    this.props.auth.logout()
      .then(() => {
        window.location.href = window.location.origin
      })
  }

  render() {
    const { auth } = this.props
    const { user } = auth

    return (
      <div className="secondary-nav stretch vertical">
        <nav className="meta-nav">
          <div className="navbar navbar-right">
            <ul>
              {user.impersonated
                ? (
                  <li className="warn">
                    <a onClick={this.handleStopImpersonating}>Stop Impersonating</a>
                  </li>
                )
                : null}
              <li><Link to="/">Startseite</Link></li>
              <li><Link to="/message/create">Kontakt</Link></li>
              <li><Link to="/help" target="_blank">Hilfe</Link></li>
              <li>|</li>
              <li><a href={FRONTEND_URL}>musbi.de</a></li>
              <li>
                v.
                {version}
              </li>
            </ul>
          </div>
        </nav>
        <nav
          id="app-user"
          className="app-user"
        >
          <div className="nav navbar navbar-right">

            Hallo
            {' '}
            {user.address}
&nbsp;
            <strong>{user.surname}</strong>
            &nbsp;
            (
            {user.identification.login}
            )

            <span className="links">

              <Link to={`/user/${user.id}/edit`}>Meine Daten</Link>
&nbsp;|&nbsp;

              {/* auth.acs.isAuthorized('SUPERADMIN')
              ? <span style={{ whiteSpace: 'nowrap' }}>
                <Link to="/settings">Systemeinstellungen bearbeiten</Link>&nbsp;|&nbsp;
              </span>
          : null */}

              <Link
                className="login-logout"
                onClick={this.handleLogout}
              >
                Logout
              </Link>

            </span>

          </div>
        </nav>
      </div>
    )
  }
}

const SecondaryNavWithRouter = withRouter(SecondaryNav)
export { SecondaryNavWithRouter as default }



// WEBPACK FOOTER //
// ./src/base/components/SecondaryNav.js